import regression from 'regression';

function Analises(data, faixaSelecionada, analiseFaixaArg) {
  var self = this;
  this.data = data;
  this.faixaSelecionada = faixaSelecionada
  // Itera o inverso das configurações disponiveis 
  // desta forma pegando apenas as ultimas configuracoes
  var item;
  this.analise = {}
  var analiseGlobal = null
  self.data.config = self.data.config.sort(function(a, b) {return a.timestamp - b.timestamp})
  for (var i = self.data.config.length - 1; i >= 0; i--) {
    item = self.data.config[i].analise
    if (item) {
      if (item.global && !analiseGlobal) {
        analiseGlobal = item.global
      }
      var itemKeys = Object.keys(item)
      for (var j = 0; j < itemKeys.length; j++) {
        var codigoFaixa = itemKeys[j]
        if (!self.analise[codigoFaixa]) {
          self.analise[codigoFaixa] = item[codigoFaixa]
        }
      }
    }
  }
  
  var analiseFaixaStore = this.analise[this.faixaSelecionada];

  if (analiseGlobal) {
    // Pega se nao tiver analise registrada para a faixa
    if (!analiseFaixaStore) {
      analiseFaixaStore = analiseGlobal
    } else {
      // Pega se este for mais atual que a analise da faixa
      if (analiseGlobal.timestamp > analiseFaixaStore.timestamp) {
        analiseFaixaStore = analiseGlobal
      }
    }
  }

  if (analiseFaixaArg) {
    this.analiseFaixa = analiseFaixaArg
  } else if (analiseFaixaStore) {
    this.analiseFaixa = analiseFaixaStore;
  } else {
    this.analiseFaixa = {
      aplicarCorrecao: false,
      lhs: "ema",
      fatorMultiplicativo: 1,
      tolVal: null,
      tolValNaUnidade: 0,
      tolUnidade: null
    };
  }

  var tolVal = parseFloat(this.analiseFaixa.tolVal);
  tolVal = isNaN(tolVal) ? 0 : tolVal;
  this.analiseFaixa.tolVal = tolVal
  this.analiseFaixa.tolValNaUnidade = this.analiseFaixa.tolValNaUnidade || 0
  this.analiseFaixa.tolUnidade = this.analiseFaixa.tolUnidade || '%'
  
  this.analiseNotas = "";

  function pegaValorUsado(ResultadoMedicao, aplicarCorrecao) {
    var valorUsado;

    if (aplicarCorrecao) {
      valorUsado = 0;
    } else {
      valorUsado = Math.abs(ResultadoMedicao);
    }

    return valorUsado;
  }

  /*
  * TODO: Verificar de outra forma a conformidade
  * quando a tolerancia e calculada com base
  * em um valor 0
  */

  function pontoEhConforme(analise, tol) {
    var analise_0 = parseFloat(analise[0].toExponential(2));
    var tol_0 = parseFloat(tol[0].toExponential(2));
    var analise_1 = parseFloat(analise[1].toExponential(2));
    var tol_1 = parseFloat(tol[1].toExponential(2));
    return analise_0 >= tol_0 && analise_1 <= tol_1;
  }

  function sumsqrd(arr) {
    var sum = 0;
    var i = arr.length;

    while (--i >= 0) {
      sum += arr[i] * arr[i];
    }

    return sum;
  }

  function anaSomaQuad(series, criterio) {
    var resSeries = series.map(function(s) {
      var fm = criterio.fatorMultiplicativo;
      var d = s.data;
      var res = [];

      for (var i = 0; i < d.ResultadoMedicao.length; i++) {
        var valorUsado = pegaValorUsado(
          d.ResultadoMedicao[i],
          criterio.aplicarCorrecao
        );
        var ema = d.ErroMaximoFaixa[i];
        var maxIncCal = d.IncertExpandidaUsada[i];
        var k = d.fatork ? d.fatork[i] : 2; //TODO exportar fator k

        res.push([
          (Math.sqrt(sumsqrd([maxIncCal / k, ema / sqrt3])) * sqrt3 +
            valorUsado) *
            fm,
          (Math.sqrt(sumsqrd([maxIncCal / k, ema / sqrt3])) * sqrt3 +
            valorUsado) *
            fm
        ]);
      }

      return res;
    });
    return {
      res: resSeries,
      notas: null
    };
  }

  function anaSomaLinear(series, criterio) {
    var resSeries = series.map(function(s) {
      var fm = criterio.fatorMultiplicativo;
      var d = s.data;
      var res = [];

      for (var i = 0; i < d.ResultadoMedicao.length; i++) {
        var valorUsado = pegaValorUsado(
          d.ResultadoMedicao[i],
          criterio.aplicarCorrecao
        );
        var ema = d.ErroMaximoFaixa[i];
        var maxIncCal = d.IncertExpandidaUsada[i];
        var k = d.fatork ? d.fatork[i] : 2; //TODO exportar fator k

        res.push([
          (maxIncCal + valorUsado) * fm,
          (maxIncCal + valorUsado) * fm
        ]);

      }

      return res;
    });
    return {
      res: resSeries,
      notas: null
    };
  }

  var sqrt3 = Math.sqrt(3);

  this.seriesFaixaFn = function() {
    return self.series.filter(function(item) {
      return item.CodigoFaixaModelo === self.faixaSelecionada;
    });
  };

  this.seriesFaixaUltimaCalFn = function() {
    var h = self.seriesFaixa[0].HoraInicial;
    return self.seriesFaixa.filter(function(item) {
      return item.HoraInicial === h;
    });
  };

  this.dadosFaixaFn = function() {
    var res = {};
    var series = self.seriesFaixaUltimaCal.map(function(item) {
      return {
        nome: item.nomeSerie,
        cod: item.cod,
        data: item.data,
        sortVal: null
      };
    });
    ["CodigoFaixaModelo", "DescFaixa", "Prefixo", "Unidade"].map(function(
      item
    ) {
      res[item] = self.seriesFaixaUltimaCal[0][item];
    });
    res.series = series;
    return res;
  };

  this.toleranciaCalculadaFn = function() {
    var resTol = self.seriesFaixaUltimaCal.map(function(s, s_i) {
      var d = s.data;
      var n = d.ResultadoMedicao.length;
      var res = [];
      var ValInstAbs;
      var fatorTol;
      var tolConst = 0;

      if (self.analiseFaixa.lhs === "auto") {
        fatorTol = self.analiseFaixa.tolVal / 100;
      } else {
        if (self.analiseFaixa.tolUnidade === "%") {
          fatorTol = self.analiseFaixa.tolVal / 100;
        } else if (self.analiseFaixa.tolUnidade === "ppm") {
          fatorTol = self.analiseFaixa.tolVal / 1e6;
        }

        var tolConstPre = parseFloat(self.analiseFaixa.tolValNaUnidade);

        if (isNaN(tolConstPre)) {
          tolConst = 0;
        } else {
          tolConst = tolConstPre;
        }
      }

      if (self.analiseFaixa.lhs === "tol") {
        for (var i = 0; i < n; i++) {
          ValInstAbs = Math.abs(d.ValorDoInstrumento[i]);
          res.push([
            -ValInstAbs * fatorTol - tolConst,
            ValInstAbs * fatorTol + tolConst
          ]);
        }
      } else if (self.analiseFaixa.lhs === "ema") {
        // ema
        for (var i = 0; i < n; i++) {
          res.push([d.ErroMinimoFaixa[i], d.ErroMaximoFaixa[i]]);
        }
      } else {
        var analisesSeries = self.funcoes[self.analiseFaixa.lhs].func(
          self.seriesFaixaUltimaCal,
          self.analiseFaixa
        );
        var analises = analisesSeries.res;
        self.analiseNotas = analisesSeries.notas;

        for (var i = 0; i < s.data.Valor.length; i++) {
          var analisePre = analises[s_i][i];
          var analise = [-analisePre[0], analisePre[1]];
          res.push(analise);
        }
      }

      return res;
    });
    return resTol;
  };

  this.constantesComputadoFn = function() {
    return self.seriesFaixaUltimaCal.map(function(s) {
      var d = s.data;
      var n = d.ErroMinimoFaixa.length;
      var res = [];

      for (var i = 0; i < n; i++) {
        var obj = {};
        obj.ema = [d.ErroMinimoFaixa[i], d.ErroMaximoFaixa[i]];
        obj.ValorDoInstrumento = d.ValorDoInstrumento[i];
        obj.Valor = d.Valor[i];
        obj.ResultadoMedicao = d.ResultadoMedicao[i];
        obj.ValorDoPadrao = d.ValorDoPadrao[i];
        obj.IncertExpandidaUsada = d.IncertExpandidaUsada[i];
        res.push(obj);
      }

      return res;
    });
  };

  this.resultadoAnalisesFn = function() {
    var analisesSeries = self.funcoes[self.analiseFaixa.lhs].func(
      self.seriesFaixaUltimaCal,
      self.analiseFaixa
    );

    var analises = analisesSeries.res;
    self.analiseNotas = analisesSeries.notas;
    var resAnalise = self.seriesFaixaUltimaCal.map(function(serie, serie_i) {
      var res = [];

      for (var i = 0; i < serie.data.Valor.length; i++) {
        var analisePre = analises[serie_i][i];
        var analise = [-analisePre[0], analisePre[1]];
        var tol = self.toleranciaCalculada[serie_i][i];
        var tolNuloSeZero = tol[0] === 0 && tol[1] === 0 ? [null, null] : tol;
        var obj = {
          analise: analise,
          tol: tolNuloSeZero,
          pontoConforme: pontoEhConforme(analise, tol),
          aplicarCorrecao: self.analiseFaixa.aplicarCorrecao
        };
        Object.keys(serie).map(function(key) {
          if (typeof serie[key] === "string") {
            obj[key] = serie[key];
          }
        });
        var constantesComputadoSeriePonto =
          self.constantesComputado[serie_i][i];
        Object.keys(constantesComputadoSeriePonto).map(function(key) {
          obj[key] = constantesComputadoSeriePonto[key];
        });
        res.push(obj);
      }

      return res;
    });
    return resAnalise;
  }; // Customizavel para cliente


  this.ponto = (val, nomeSerie) => {

    return self.seriesFaixaUltimaCal.filter((serie) => {
        if (!nomeSerie) return true
        return serie.nomeSerie === nomeSerie
    }).map((serie, serie_i) => {
      let uAnalise = this.resultadoAnalises[serie_i]
        .map(v => v.analise[1])
      
      let data = serie.data
      let matrix = data.ValorDoInstrumento.map((instVal, i) => 
        Object({
          sort: Math.abs(val - instVal),
          vc: data.ValorDoPadrao[i],
          vi: data.ValorDoInstrumento[i],
          u: uAnalise[i],
          k: data.fatork[i]
        })
      )
      
      matrix = matrix.sort((a, b) => a.sort - b.sort)
      let k = matrix[0].k

      if (matrix.length === 1) {
        matrix.push(matrix[0])
      }      
      
      let valCorr = val
      if (!this.analise.aplicarCorrecao) {
        let m = (matrix[1].vc-matrix[0].vc)/(matrix[1].vi-matrix[0].vi)
        let b = matrix[0].vc - m*matrix[0].vi
        valCorr = val*m + b
      }

      let mu = (matrix[1].u-matrix[0].u)/(matrix[1].vi-matrix[0].vi)
      let bu = matrix[0].u - mu*matrix[0].vi
      let u = val*mu + bu        
      
      return {nomeSerie: serie.nomeSerie, res: {valor: valCorr, u: u, k: k} }
    }).reduce((a, c) => {
      a[c.nomeSerie] = c.res
      return a
    }, {})
  }

  this.executa = function() {
    self.series = self.data.seriesDenormRes
    self.seriesFaixa = self.seriesFaixaFn()
    self.seriesFaixaUltimaCal = self.seriesFaixaUltimaCalFn()
    self.dadosFaixa = self.dadosFaixaFn()
    self.toleranciaCalculada = self.toleranciaCalculadaFn()
    self.constantesComputado = self.constantesComputadoFn()
    self.resultadoAnalises = self.resultadoAnalisesFn()
    return self.resultadoAnalises
  }

  this.funcoes = {
    // Registra analises padrao
    ema: {
      desc: "Certificado de Calibração",
      tipoAnalise: 'criterioAceitacao',
      func: anaSomaLinear
    },
    tol: {
      desc: "Tolerância",
      tipoAnalise: 'criterioAceitacao',
      func: anaSomaLinear
    },
    somaQuadUEMAMaisE: {
      desc: "Análise por faixa - Caso B",
      detalhes: "",
      detalhesExtra: "",
      tipoAnalise: "incertezaASerUtilizada",
      func: function (series, criterio) {
        var _fm = criterio.fatorMultiplicativo; // Necessário para as notas não sumirem quando o usuário altera o fator

        var driftNota = "<b>Variação da Nova Incerteza em relação ao EMA do fabricante:</b>\n";
        var resSeries = series.map(function (s) {
          var d = s.data;
          var res = [];

          for (var i = 0; i < d.ResultadoMedicao.length; i++) {
            var ponto = d.Valor[i] + " " + s.Prefixo + s.Unidade;
            var nomeSerie = series.length !== 1 ? " (" + s.nomeSerie + ")" : "";
            var erro = pegaValorUsado(d.ResultadoMedicao[i], criterio.aplicarCorrecao);
            var maxIncCal = Math.abs(d.IncertExpandidaUsada[i]);
            var ema = Math.abs(d.ErroMaximoFaixa[i]); // Pelo critério do laboratório, aplicar apenas erro se não estiver conforme

            var componenteErro = erro + maxIncCal <= ema ? 0 : erro;
            var k = d.fatork[i] || 2;
            var ana = (Math.sqrt(sumsqrd([maxIncCal / k, ema / sqrt3])) * sqrt3 + componenteErro) * 0.95;
            var variacao = (ana - ema) / ema * 100;

            if (variacao > 0) {
              variacao = '<span style="color: red;">' + parseFloat(variacao.toPrecision(2)) + " %</span>";
            } else {
              variacao = '<span style="color: green;">' + parseFloat(variacao.toPrecision(2)) + " %</span>";
            }

            driftNota += "" + ponto.toString() + ": " + variacao + nomeSerie + "\n";
            res.push([ana, ana]);
          }

          return res;
        });
        return {
          res: resSeries,
          notas: driftNota
        };
      }
    },
    AvaliacaoVolks: {
      desc: 'Avaliação Volks',
      detalhes: '',
      detalhesExtra: '',
      tipoAnalise: 'incertezaASerUtilizada',
      func: function (series, criterio) {
        var VMarr = [];
        var resSeries = series.map( function(s, s_i) {
          const d = s.data;
          var res = [];

          for (var i = 0; i < d.ResultadoMedicao.length; i++) {
            var valorUsado = pegaValorUsado(d.ResultadoMedicao[i], criterio.aplicarCorrecao);
            var ema = d.ErroMaximoFaixa[i];
            var maxIncCal = d.IncertExpandidaUsada[i];
            var vInst = d.ValorDoInstrumento[i];
            VMarr.push(Math.sqrt(sumsqrd([Math.abs(maxIncCal / vInst) * 100, Math.abs(valorUsado / vInst) * 100])));
            var sq = Math.sqrt(sumsqrd([maxIncCal, valorUsado]));
            res.push([sq, sq]);
          }

          return res;
        });
        var analise = '';
        var VMArrNumerosValidos = VMarr.filter(function (item) {
          return isFinite(item) && typeof item === 'number';
        });
        var maxVM = Math.max.apply(undefined, VMArrNumerosValidos);

        if (!maxVM) {
          analise = 'Não aplicável';
        } else {
          var classe, nivel;

          if (maxVM <= 0.001) {
            classe = '00';
            nivel = '1';
          } else if (maxVM <= 0.01) {
            classe = '0';
            nivel = '2';
          } else if (maxVM <= 0.1) {
            classe = '1';
            nivel = '3';
          } else if (maxVM <= 0.5) {
            classe = '2';
            nivel = '4';
          } else if (maxVM <= 1) {
            classe = '3';
            nivel = '5';
          } else if (maxVM <= 3) {
            classe = '4';
            nivel = '6';
          } else if (maxVM <= 5) {
            classe = '5';
            nivel = '7';
          } else {
            classe = '6';
            nivel = '8';
          }

          analise += 'Classe de exatidão: ' + classe + '\n';
          analise += 'Nível hierárquico: ' + nivel + '\n';
        }

        return {
          res: resSeries,
          notas: analise
        };
      }
    }
  };
}

export {Analises}